/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { SimpleSlider } from "../basic/simple-slider.js";
import { wrapCollectionLayout } from "@quintype/components";
import PropTypes from "prop-types";
import { isEager, getRowMetadata } from "../../utils";

function FullscreenSimpleSliderBase({ collection, stories = [], config, associatedMetadata, index }) {
  const pbAheadConfig = getRowMetadata(config, associatedMetadata);
  return (
    <div className="component-wrapper" data-test-id="full-screen-simple-slider">
      <SimpleSlider
        eager={isEager(index, true)}
        stories={stories}
        config={config}
        heading={collection.name}
        associatedMetadata={pbAheadConfig}
      />
    </div>
  );
}

FullscreenSimpleSliderBase.propTypes = {
  config: PropTypes.object,
  associatedMetadata: PropTypes.object,
  collection: PropTypes.object,
  stories: PropTypes.array,
  index: PropTypes.number
};

export const FullscreenSimpleSlider = wrapCollectionLayout(FullscreenSimpleSliderBase);

FullscreenSimpleSlider.storyLimit = 12;
